import { useCallback, useRef, useState } from 'react';

export const useActionAfterAutosave = (flush: () => Promise<boolean>) => {
  const [isWaiting, setIsWaiting] = useState(false);
  const isWaitingRef = useRef(false);

  const runAfterAutosave = useCallback(
    async (action: () => void) => {
      if (isWaitingRef.current) {
        return;
      }

      isWaitingRef.current = true;
      setIsWaiting(true);

      const isSaved = await flush();

      isWaitingRef.current = false;
      setIsWaiting(false);

      if (isSaved) {
        action();
      }
    },
    [flush],
  );

  return { isWaiting, runAfterAutosave };
};

export default useActionAfterAutosave;
